"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteTab = exports.RouteTabs = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _palette = require("@artsy/palette");

var _Router = require("../../Artsy/Router");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RouteTabs = (0, _styledComponents.default)(_palette.TabsContainer).withConfig({
  displayName: "RouteTabs",
  componentId: "h84f08-0"
})(["a{", ";:not(:last-child){margin-right:", "px;}color:", ";text-decoration:none;&.active{color:", ";", ";}}"], _palette.sharedTabsStyles.tabContainer, (0, _palette.space)(3), (0, _palette.color)("black30"), (0, _palette.color)("black100"), _palette.sharedTabsStyles.activeTabContainer);
exports.RouteTabs = RouteTabs;

var RouteTab = function RouteTab(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(_Router.PreloadLink, props, _react.default.createElement(_palette.Sans, {
    size: "3t",
    weight: "medium"
  }, children));
};

exports.RouteTab = RouteTab;
RouteTabs.displayName = "RouteTabs";
RouteTab.displayName = "RouteTab";
//# sourceMappingURL=RouteTabs.js.map